// import { sprintf } from '../../../third_party/sprintf-js';
import { translate } from '../../locales/i18n';
import {
  guideNameValidation,
  guideDescValidation,
  appNameValidation,
  appDescValidation,
  appPriceValidation,
  appRentDurationValidation,
} from '../validation/App';
import {
  nameValidation,
  extraStayValidation,
} from '../validation/Endpoint';
import { language } from '../../localization';

class App {
  // FIXME(clairbee): get rid if these magic numbers
  static DEFAULT_LAT_DELTA = 0.0922;

  static DEFAULT_LON_DELTA = 0.0421;

  static createFromData(data) {
    const app = new App();
    if (data) {
      if (data.data) {
        app.data = JSON.parse(data.data);
        app.data.uuid = data.uuid;
        app.data.user = data.user;
        app.data.lang = data.lang;
        // app.data.route = data.route;
        app.data.endpoints = data.endpoints;
        // app.data.origin = data.origin;
      } else {
        app.data = data;
      }
    }
    app.postProcessed = false;
    // console.log('created app from data');
    // console.log(app);

    return app;
  }

  constructor() {
    this.data = {
      __typename: 'App',
      // uuid: 1,
      lang: language(),
      // seo_id: "the_best_app_over_here",
      // TODO(clairbee): fill in the guide info from the profile
      // guideName: 'Anna Kuzmenko',
      // guideDesc: 'A local history fan who enjoys giving apps.',
      // name: 'The best app over here',
      // desc: 'Walk around this neighbourhood. Stare in other people&#39;s windows. Emerge yourself into new experience with your family!',
      travelType: 0, // walking
      // location: { lat: 37.35, lng: -121.93 },
      tag1: null,
      tag2: null,
      tag3: null,
      tag4: null,
      tag5: null,
      type: 0,
      currency: 'USD',
      // buyPrice: 5,
      // rentPrice: 2.5,
      // rentDays: 14,
      promoted: false,
      reviews: 0,
      rating: 0,
      // duration: 167,
      endpoints: [],
      endpointIds: '[]',
    };
  }

  createFromUser(user) {
    this.data.user = user.sub; // FIXME(clairbee): is this correct?

    this.postProcessed = false;

    return this;
  }

  makeOptimistic() {
    if (!this.data.uuid) {
      this.data.uuid = 'not-inserted-yet-%s' % Math.random().toString();
    }
    return this;
  }

  output() {
    // console.log('output');
    // console.log(this.data);
    return this.data;
  }

  postProcess() {
    if (this.postProcessed) {
      return;
    }
    this.postProcessed = true;

    // console.log('App.postProcess()');
    // console.log(this.data);

    this.pp = this.data ? JSON.parse(JSON.stringify(this.data)) : {};
    this.pp.link = `/ai-agent/${this.data.uuid}`;
    // // this.pp.guideName = this.data.guideName;
    // // this.pp.guideDesc = 'A local history fan who enjoys giving apps.';
    // // this.pp.name = this.data.name;
    // // this.pp.desc = this.data.description;
    // // this.pp.reviews = `(${this.data.reviews})`;
    // this.pp.travelType = this.data.travelType;
    // // // this.pp.reviews = "(" + this.reviewRating + "/5) " + this.reviews + " reviews";
    // // // this.pp.image = (<img src={this.image || camera} />);
    // // this.pp.duration = sprintf('%d:%02d', Math.floor(this.data.duration / 60), (this.data.duration % 60));
    // // this.pp.currency = '$';
    // // this.pp.buyPrice = sprintf('%0.02f', this.data.buyPrice);
    // // this.pp.rentPrice = sprintf('%0.02f', this.data.rentPrice);
    // // this.pp.rentDays = sprintf('%d', this.data.rentDays);
    // // this.pp.price = `${this.pp.buyPrice} / ${this.pp.rentPrice}`;
    // // this.pp.promoted = this.data.promoted;

    // TODO(clairbee): do not use pp for anything but text
    // this.pp.endpoints = this.data.endpoints;

    this.pp.endpointIds = (this.data.endpointIds && this.data.endpointIds !== '') ? JSON.parse(this.data.endpointIds) : [];

    // make sure the endpoint ID of all existing endpoints is in the list of endpoints
    const found = [];
    if (this.pp.endpoints) {
      this.pp.endpoints.forEach((endpoint) => {
        found.push(endpoint.uuid);
        if (!this.pp.endpointIds.includes(endpoint.uuid)) {
          this.pp.endpointIds.push(endpoint.uuid);
        }
      });
    }

    // remove endpoint IDs that are not found in the list of endpoints
    this.pp.endpointIds = this.pp.endpointIds.filter((uuid) => found.includes(uuid));
  }

  getIssues() {
    const issues = [];

    this.postProcess();

    // console.log('getIssues');
    // console.log(this.data);

    if (!guideNameValidation.isValidSync(this.data.guideName)) {
      issues.push({
        text: translate('issue-guide-name-text'),
        description: translate('issue-guide-name-desc'),
      });
    }

    if (!guideDescValidation.isValidSync(this.data.guideDesc)) {
      issues.push({
        text: translate('issue-guide-desc-text'),
        description: translate('issue-guide-desc-desc'),
      });
    }

    if (!this.data.guideImage) {
      issues.push({
        text: translate('issue-guide-image-text'),
        description: translate('issue-guide-image-desc'),
      });
    }

    if (!appNameValidation.isValidSync(this.data.name)) {
      issues.push({
        text: translate('issue-app-name-text'),
        description: translate('issue-app-name-desc'),
      });
    }

    if (!appDescValidation.isValidSync(this.data.desc)) {
      issues.push({
        text: translate('issue-app-desc-text'),
        description: translate('issue-app-desc-desc'),
      });
    }

    if (!this.data.image) {
      issues.push({
        text: translate('issue-app-image-text'),
        description: translate('issue-app-image-desc'),
      });
    }

    if (!this.data.endpoints.length > 0) {
      issues.push({
        text: translate('issue-endpoint-none-text'),
        description: translate('issue-endpoint-none-desc'),
      });
    }

    if (this.data.travelType !== 3 && this.data.route === null) {
      issues.push({
        text: translate('issue-app-route-none-text'),
        description: translate('issue-app-route-none-desc'),
      });
    }

    if (this.data.type === 1 || this.data.type === 3) {
      if (!this.data.rentPrice || !appPriceValidation.isValidSync(this.data.rentPrice)) {
        issues.push({
          text: translate('issue-rent-price-text'),
          description: translate('issue-rent-price-desc'),
        });
      }
      if (!this.data.rentDays || !appRentDurationValidation.isValidSync(this.data.rentDays)) {
        issues.push({
          text: translate('issue-rent-duration-text'),
          description: translate('issue-rent-duration-desc'),
        });
      }
    }

    if (this.data.type === 2 || this.data.type === 3) {
      if (!this.data.buyPrice || !appPriceValidation.isValidSync(this.data.buyPrice)) {
        issues.push({
          text: translate('issue-buy-price-text'),
          description: translate('issue-buy-price-desc'),
        });
      }
    }

    if (this.pp.endpointIds.length > 0) {
      for (let i = 0; i < this.pp.endpointIds.length; i += 1) {
        for (let j = 0; j < this.data.endpoints.length; j += 1) {
          if (this.data.endpoints[j].uuid === this.pp.endpointIds[i]) {
            const seq = i + 1;
            const { name } = this.data.endpoints[j];

            if (!nameValidation.isValidSync(name)) {
              issues.push({
                text: translate('issue-endpoint-name-text', { seq, name }),
                description: translate('issue-endpoint-name-desc', { seq, name }),
              });
            }

            if (!extraStayValidation.isValidSync(this.data.endpoints[j].extraStay)) {
              issues.push({
                text: translate('issue-endpoint-stay-text', { seq, name }),
                description: translate('issue-endpoint-stay-desc', { seq, name }),
              });
            }

            if (!this.data.endpoints[j].track) {
              issues.push({
                text: translate('issue-endpoint-track-text', { seq, name }),
                description: translate('issue-endpoint-track-desc', { seq, name }),
              });
            } else if (!this.data.endpoints[j].duration || this.data.endpoints[j].duration < 15) {
              issues.push({
                text: translate('issue-endpoint-duration-text', { seq, name, duration: 15 }),
                description: translate('issue-endpoint-duration-desc', { seq, name, duration: 15 }),
              });
            }
          }
        }
      }
    }

    if (issues.length === 0) {
      this.data.completed = true;
    }

    return issues;
  }
}

export default App;
